import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};
`;
export const LanguageButton = styled.button `
  appearance: none;
  text-decoration: none;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.spacing.md} ${theme.spacing.lg};
  border-radius: ${theme.borderRadius.md};
  border: solid ${pxToRem(1)} ${theme.semantic.border.default};
  background-color: ${(props) => (props.$selected ? theme.semantic.surface.sunken : theme.semantic.surface.primary)};
  transition: all 175ms ease-out;

  &:hover {
    cursor: pointer;
    border-color: ${theme.swatches.warm[700]};
    background-color: ${theme.semantic.surface.sunken};
  }
`;
